/**
 * @features/dashboard/components/Guard.jsx
 * ----------------------------------------
 * Declarative permission gate. Renders children only if the current user
 * holds the listed permission(s); otherwise renders `fallback` (default
 * `null`).
 *
 *   <Guard perm="property:approve">
 *     <ApproveButton />
 *   </Guard>
 *
 *   <Guard anyOf={["lead:view", "lead:view-own"]}>
 *     <LeadsTable />
 *   </Guard>
 *
 *   <Guard perm="admin:*" fallback={<UpgradeCTA />}>
 *     <PaywalledFeature />
 *   </Guard>
 *
 * v2.71.27 — Initial.
 */

import React from "react";
import { useAuth } from "../../../lib/AuthContext";
import { can } from "../config/permissions";

export function Guard({ perm, anyOf, allOf, fallback = null, children }) {
  const { user } = useAuth();
  let allowed = false;
  if (perm) allowed = can(user, perm);
  else if (anyOf?.length) allowed = anyOf.some((p) => can(user, p));
  else if (allOf?.length) allowed = allOf.every((p) => can(user, p));
  return allowed ? <>{children}</> : <>{fallback}</>;
}
